<template>
  <el-container class="chat-page">
    <chat-box v-if="activeConv" :conversation="activeConv"></chat-box>
  </el-container>
</template>

<script>
import ChatBox from "../components/chat/ChatBox.vue";

export default {
  name: "chat",
  components: {
    ChatBox
  },
  methods: {
    setFirstActiveIfNeeded() {
      this.chatStore.setFirstActiveIfNeeded();
    }
  },
  computed: {
    activeConv() {
      return this.chatStore.activeConversation;
    },
    conversationSize() {
      return this.chatStore.conversations.length;
    }
  },
  watch: {
    conversationSize: {
      immediate: true,
      handler() {
        this.setFirstActiveIfNeeded();
      }
    },
    activeConv(val) {
      if (!val) {
        this.setFirstActiveIfNeeded();
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.chat-page {
  width: 100%;
  height: 100%;
  flex: 1;

  .chat-box {
    height: 100%;
    flex: 1;
    min-width: 0;
  }
}
</style>
